import * as Sentry from '@sentry/browser'
import packageJson from '../../../package.json'

export const setupSentry = (app) => {
  if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      release: packageJson.version
    })
    app.config.errorHandler = (...args) => {
      console.error(...args)
      Sentry.captureException(...args)
    }
  }
}
